export function formatEquipmentName(
  name: string,
  manufacturer?: string | null,
): string {
  if (manufacturer) return `${manufacturer} ${name}`;
  return name;
}
